import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { personTitles } from '../../constants';
import { AutoComplete, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const titles = personTitles;

const TitleSelect = ({ onSelection, selectedTitles, appendTitles, value }) => {
  const [titleValue, setTitleValue] = useState(value || '');
  const [inputValue, setInputValue] = useState(value || '');
  const hideTitles = selectedTitles && selectedTitles.length > 0;

  const originalTitleItems = useMemo(() => {
    let items = titles;
    if (appendTitles) items = appendTitles.concat(items);
    if (hideTitles) items = titles.filter(title => !selectedTitles.includes(title));
    return [...items];
  }, [appendTitles, hideTitles, selectedTitles]);

  const titleItems = useMemo(() => {
    const items = [...originalTitleItems];
    const nextInput = inputValue || '';
    const hasTitle = titles.find(t => t.toLowerCase().startsWith(nextInput.toLowerCase()));

    if (nextInput.trim() && !hasTitle) items.push(nextInput);
    return items;
  }, [originalTitleItems, inputValue]);

  const renderOption = (props, option) => {
    const isCustom = !originalTitleItems.includes(option);
    return <li {...props}>{isCustom ? <>Add <Typography component="span" variant="subtitle1" sx={{ px: .5 }}>{option}</Typography> as title</> : option}</li>;
  };

  const onSelectChanged = value => {
    setTitleValue(value);
    setInputValue(value);
    if (onSelection) onSelection(value);
  };

  const handleInputChange = (_event, nextInputValue, reason) => {
    const nextValue = nextInputValue || '';
    if (nextValue?.length === 76) return;
    setInputValue(nextValue);

    // Some wrapped Autocomplete builds emit selection through input reset on option click.
    if (reason === 'reset') {
      onSelectChanged(nextValue);
    }
  };

  const handleChange = (_event, nextValue) => {
    const selectedValue = typeof nextValue === 'string' ? nextValue : (nextValue || '');
    onSelectChanged(selectedValue);
  };

  return <AutoComplete
    options={titleItems}
    freeSolo
    openOnFocus
    value={titleValue}
    inputValue={inputValue}
    getOptionLabel={option => (typeof option === 'string' ? option : '')}
    onInputChange={handleInputChange}
    onChange={handleChange}
    renderOption={renderOption}
    placeholder='Title'
    textFieldProps={{ id: 'title-select', autoFocus: true }}
  />;
};

TitleSelect.propTypes = {
  value: PropTypes.string,
  onSelection: PropTypes.func,
  selectedTitles: PropTypes.array,
  appendTitles: PropTypes.array
};

export default TitleSelect;
